import "./fullPage.scss"

export const fullPage = {
  template: `
    <div class='full-page'>
      <div class='full-page-contents' ng-transclude></div>
    </div>
  `,
  transclude: true
}